import {
  CalculatorBodyText,
  CalculatorHeadline,
  CalculatorImageDescriptionText,
  CalculatorTextCenter,
  CalculatorTopicH2Headline,
  CalculatorTopicH3Headline,
  CalculatorTopicHeadline,
  PreCalculatorHeadline,
} from "src/components/Calculator/CalculatorTypography";
import React, { FC, useEffect, useRef } from "react";
import { makeStyles, useTheme } from "@material-ui/styles";

import { CalculatorButton } from "src/components/Calculator/components/CalculatorButton";
import { CalculatorImage } from "src/components/Calculator/CalculatorImage";
import { TheCycleverseTheme } from "src/theme";
import useTranslation from "next-translate/useTranslation";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  main: {
    marginTop: 30,
    marginBottom: 35,
  },
  headImage: {
    marginTop: 50,
    marginBottom: 80,
  },
  calc: {
    minWidth: 200,
    [theme.breakpoints.down("xs")]: {
      maxWidth: "100%",
    },
    // [theme.breakpoints.up("sm")]: {
    //   width: "100vw",
    //   position: "relative",
    //   left: "calc(-50vw + 50%)",
    // },
  },
  externalCalc: {
    marginTop: 60,
    marginBottom: 100,
    maxWidth: theme.widths.calculatorWidth,
  },
  paragraph1: {
    marginTop: 60,
    marginBottom: 70,
  },
  list: {
    padding: "0 12px",
    fontSize: "16px",
    marginLeft: "7px",
  },
  noSpaceTop: {
    marginTop: 0,
    paddingTop: 0,
  },
}));

declare global {
  interface Window {
    ensPreset: any;
    ensOptions: any;
    ensStyling: any;
  }
}

const VersicherungsRechner = () => {
  const ref = useRef(null);
  const classes = useStyles();
  const theme = useTheme<TheCycleverseTheme>();
  const { t } = useTranslation("fahrradEbikeVersicherungVergleichsrechner");

  {
    /* <div id="ensurance_view_root"></div>
<script>
window.ensPreset = {
presetId: "6231a8052ab2b0.62109697"
}
</script>
<script src="https://ebikeversicherungen.net/wp-json/ens/v1/inclusion/enscompare" async></script> */
  }

  useEffect(() => {
    const element = ref?.current;
    if (typeof window !== "undefined" && element) {
      window.ensPreset = {
        presetId: "6231a8052ab2b0.62109697",
      };
      window.ensOptions = {
        refererOverride: "6231a8052ab2b0.62109697",
        domRoot: "ensurance_view_root",
        customCssUrl: "https://dev.thecycleverse.com/misc/fahrrad-versicherung.css",
      };
      window.ensStyling = {
        primary: "#0096ff",
        secondary: [
          "#05B709",
          "#05B709",
          "#05B709",
          "#05B709",
          "#05B709",
          "#05B709",
          "#05B709",
          "#05B709",
          "#05B709",
          "#05B709",
        ],
      };
      const script = document.createElement("script");
      script.src = "https://ebikeversicherungen.net/wp-json/ens/v1/inclusion/enscompare";
      script.async = true;
      element.appendChild(script);
      return () => {
        element.removeChild(script);
      };
    }
  }, [ref, classes]);

  return (
    <>
      <CalculatorImage
        src="/images/calculators/fahrrad-e-bike-versicherung-vergleichsrechner/E-Bike-und-Fahrradversicherungen-Vergleichsrechner.svg"
        width={500}
        layout="intrinsic"
        alt={t("headerimageAlt")}
        classMain={classes.headImage}
      />

      <CalculatorBodyText className={classes.paragraph1}>{t("paragraph1")}</CalculatorBodyText>

      <CalculatorHeadline>{t("headline3")}</CalculatorHeadline>

      <div className={classes.externalCalc} id="Rechner">
        <div className={classes.main} ref={ref} />
        <div className={classes.calc} id="ensurance_view_root" />
      </div>

      <CalculatorHeadline>{t("headline4")}</CalculatorHeadline>

      <CalculatorImage
        src="/images/calculators/fahrrad-e-bike-versicherung-vergleichsrechner/E-Bike-und-Fahrradversicherung-Fahrrad.jpg"
        width={theme.widths.calculatorWidth}
        layout="intrinsic"
        alt={t("headerimage2Alt")}
      />
      <CalculatorImageDescriptionText>{t("headerimage2Description")}</CalculatorImageDescriptionText>

      <CalculatorBodyText>{t("paragraph2")}</CalculatorBodyText>
      <CalculatorBodyText>{t("paragraph3")}</CalculatorBodyText>

      <CalculatorTopicH3Headline>{t("headline5")}</CalculatorTopicH3Headline>
      <CalculatorBodyText className={classes.noSpaceTop}>{t("paragraph4")}</CalculatorBodyText>
      <ul className={classes.list}>
        <li>{t("paragraph4Li1")}</li>
        <li>{t("paragraph4Li2")}</li>
        <li>{t("paragraph4Li3")}</li>
      </ul>
      <CalculatorBodyText>{t("paragraph5")}</CalculatorBodyText>

      <CalculatorTopicH3Headline>{t("headline6")}</CalculatorTopicH3Headline>
      <CalculatorBodyText className={classes.noSpaceTop}>{t("paragraph6")}</CalculatorBodyText>
      <ul className={classes.list}>
        <li>{t("paragraph6Li1")}</li>
        <li>{t("paragraph6Li2")}</li>
        <li>{t("paragraph6Li3")}</li>
        <li>{t("paragraph6Li4")}</li>
        <li>{t("paragraph6Li5")}</li>
        <li>{t("paragraph6Li6")}</li>
        <li>{t("paragraph6Li7")}</li>
      </ul>

      <CalculatorTopicH3Headline>{t("headline7")}</CalculatorTopicH3Headline>
      <CalculatorBodyText className={classes.noSpaceTop}>{t("paragraph7")}</CalculatorBodyText>
      <ul className={classes.list}>
        <li>{t("paragraph7Li1")}</li>
        <li>{t("paragraph7Li2")}</li>
        <li>{t("paragraph7Li3")}</li>
        <li>{t("paragraph7Li4")}</li>
        <li>{t("paragraph7Li5")}</li>
      </ul>

      <CalculatorTopicH3Headline>{t("headline8")}</CalculatorTopicH3Headline>
      <CalculatorBodyText className={classes.noSpaceTop}>{t("paragraph8")}</CalculatorBodyText>

      <CalculatorButton text={t("startCalculator")} scroll idToScrollTo="Rechner" />

      <CalculatorTopicH3Headline>{t("headline9")}</CalculatorTopicH3Headline>
      <CalculatorBodyText className={classes.noSpaceTop}>{t("paragraph9")}</CalculatorBodyText>
      <CalculatorBodyText>{t("paragraph10")}</CalculatorBodyText>
      <CalculatorBodyText>{t("paragraph11")}</CalculatorBodyText>
      <CalculatorBodyText>{t("paragraph12")}</CalculatorBodyText>
      <CalculatorBodyText>{t("paragraph13")}</CalculatorBodyText>
      <CalculatorBodyText>{t("paragraph14")}</CalculatorBodyText>

      <CalculatorButton text={t("startCalculator")} scroll idToScrollTo="Rechner" />

      <CalculatorHeadline>{t("headline10")}</CalculatorHeadline>

      <CalculatorImage
        src="/images/calculators/fahrrad-e-bike-versicherung-vergleichsrechner/E-Bike-und-Fahrradversicherung-Abgestelltes-Fahrrad.jpg"
        width={theme.widths.calculatorWidth}
        layout="intrinsic"
        alt={t("headerimage3Alt")}
      />
      <CalculatorImageDescriptionText>{t("headerimage2Description")}</CalculatorImageDescriptionText>

      <CalculatorTopicH3Headline>{t("headline11")}</CalculatorTopicH3Headline>
      <CalculatorBodyText className={classes.noSpaceTop}>{t("paragraph15")}</CalculatorBodyText>

      <CalculatorTopicH3Headline>{t("headline12")}</CalculatorTopicH3Headline>
      <CalculatorBodyText className={classes.noSpaceTop}>{t("paragraph16")}</CalculatorBodyText>

      <CalculatorTopicH3Headline>{t("headline13")}</CalculatorTopicH3Headline>
      <CalculatorBodyText className={classes.noSpaceTop}>{t("paragraph17")}</CalculatorBodyText>

      <CalculatorTopicH3Headline>{t("headline14")}</CalculatorTopicH3Headline>
      <CalculatorBodyText className={classes.noSpaceTop}>{t("paragraph18")}</CalculatorBodyText>

      <CalculatorTopicH3Headline>{t("headline15")}</CalculatorTopicH3Headline>
      <CalculatorBodyText className={classes.noSpaceTop}>{t("paragraph19")}</CalculatorBodyText>

      <CalculatorTopicH3Headline>{t("headline16")}</CalculatorTopicH3Headline>
      <CalculatorBodyText className={classes.noSpaceTop}>{t("paragraph20")}</CalculatorBodyText>

      <CalculatorTopicH3Headline>{t("headline17")}</CalculatorTopicH3Headline>
      <CalculatorBodyText className={classes.noSpaceTop}>{t("paragraph21")}</CalculatorBodyText>

      <CalculatorButton text={t("startCalculator")} scroll idToScrollTo="Rechner" />
    </>
  );
};

export default VersicherungsRechner;
